<div class="logout">
    <message icon="check_circle"
             message="Sie haben sich erfolgreich ausgeloggt."
             [showLinkToStart]="false"
    ></message>
</div>
